/**
 * Enabling MoveOn functionality for Workspace Preview flow
 * This file is intended to support the preview functionality
 * TODO: Move away from deprecated LegacyAPI implementation
 */

import CoursewareTargetProvider from 'pluginServices/services/CoursewareTargetService';
import pathwayService from 'services/PathwayService';
import * as pluginServices from 'pluginServices';

const moveOnSubscriptions = {};

export default class DeprecatedResourceService {
  constructor({ id }) {
    this.id = id;
    this.targetProvider = CoursewareTargetProvider.build();
  }

  async moveOn() {
    const { ancestry } = await this.targetProvider.createTarget(this.id);
    const pathways = ancestry.filter(({ elementType }) => elementType === 'PATHWAY');
    this._getNextActivity(ancestry, pathways, this.id);
  }

  async _getNextActivity(ancestry, pathways, id) {
    let nextActivityIndex = 0;
    const { elementId: pathwayId } = pathways.shift();
    const { children } = await pathwayService.getPathway(pathwayId);
    // TODO: if interactiveID found in pathway keep looping, if we reach end of pathway,
    // trace back to the ancestor Activity and get next pathway or keep tracking back
    if (id) {
      nextActivityIndex = children.findIndex((child) => child.elementId === id) + 1;
      // nextActivityIndex = children.map((child) => child.elementId).indexOf(id) + 1;
      if (nextActivityIndex >= children.length) {
        const activities = ancestry.filter(({ elementType }) => elementType === 'ACTIVITY');
        if(activities.length) {
          await this._getNextActivity(ancestry, pathways, activities[0].elementId);
        }
        return;
      }
    }
    const { elementId, elementType } = children[nextActivityIndex];
    // only if its an interactive update
    // Activities in the pathway should be handled separately
    if (elementType === 'INTERACTIVE' || elementType === 'ACTIVITY') {
      const target = { id: elementId, type: elementType, ancestry };
      pluginServices.initializeRoute({ target }).routeTo();
    }
  }

  subscribeToMoveOn(targetId, notify) {
    const subscription = {
      id: targetId, // We don't allow multiple subscriptions (not perfect) so this is okay.
      notify,
    };
    moveOnSubscriptions[subscription.id] = subscription;
  }

  unsubscribeFromMoveOn(subscription) {
    delete moveOnSubscriptions[subscription.id];
  }

  static build(args) {
    return new DeprecatedResourceService(args);
  }
}
